import { render, staticRenderFns } from "./RaceRunners.vue?vue&type=template&id=2c9849c9&scoped=true&"
import script from "./RaceRunners.vue?vue&type=script&lang=js&"
export * from "./RaceRunners.vue?vue&type=script&lang=js&"
import style0 from "./RaceRunners.vue?vue&type=style&index=0&id=2c9849c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9849c9",
  null
  
)

export default component.exports